var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import uniqueId from 'lodash/uniqueId';
import PdpSubmissionItem from './pdpSubmissionItem';
import { withNurseryContext } from '../../contexts/NurseryContext';
var PdpSubmission = /** @class */ (function (_super) {
    __extends(PdpSubmission, _super);
    function PdpSubmission() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.launchCarousel = function (e) {
            e.preventDefault();
        };
        return _this;
    }
    PdpSubmission.prototype.render = function () {
        var _this = this;
        var _a = this.props, title = _a.title, data = _a.data, nurserySlug = _a.nurserySlug;
        var filteredItems = data.filter(function (item) {
            if (nurserySlug
                && !item.is_photo
                && item.contributor_info.is_nursery) {
                return item.contributor_info.slug === nurserySlug;
            }
            return true;
        });
        var items = filteredItems.map(function (item, index) { return (React.createElement(PdpSubmissionItem, { key: uniqueId(item.contributor_info.name), data: item, title: title, launchCarousel: _this.launchCarousel, activeIndex: index })); });
        return (items && items.length > 0) && (React.createElement("div", { className: "submissions_wrapper" },
            React.createElement("div", { className: "submissions" },
                React.createElement("h2", null, "Garden photo gallery of ".concat(title)),
                React.createElement("div", { className: "submissions_grid" }, items))));
    };
    return PdpSubmission;
}(React.Component));
export default withNurseryContext(PdpSubmission);
